// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBoXSzYVbvf_ifKx4YCH619mRLDoH5z7-4",
  authDomain: "g2itest.firebaseapp.com",
  projectId: "g2itest",
  storageBucket: "g2itest.appspot.com",
  messagingSenderId: "121405272044",
  appId: "1:121405272044:web:97cab1d894bfdc910d1ac9"
};

export default firebaseConfig
